import React from 'react';
import { NA_VALUE, UNIQUE_SIZE } from '@yme/common/constants';
import { buildKey, noop } from '@yme/common/index';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { ButtonRectangleRadio } from './ButtonRectangleRadio';
export function ButtonRectangleRadioGroup(props) {
    const { contentTag = RegularTextLevel4, setActiveOption, selectedValue = '', dataTestId, keyOfColorGroup = 'key', allowClickOnDisabled, isRadioVisible, isWidthFlexible = false, 
    // main collection
    allOptions = [], 
    // external collection for define possible options and show on UI as disabled
    possibleOptions = [], } = props;
    const { isTabletView, isLargeDesktopView } = useWindowSize();
    const setIsActiveHandler = (value) => () => {
        if (setActiveOption && value) {
            setActiveOption(value);
        }
    };
    const possibleOptionsCleared = possibleOptions
        ? possibleOptions.filter((item) => Boolean(item))
        : [];
    const allOptionsCleared = allOptions ? allOptions.filter((item) => Boolean(item)) : [];
    if (possibleOptionsCleared?.length && allOptionsCleared?.length) {
        return (React.createElement(React.Fragment, null, allOptionsCleared.map((option, index) => {
            const { value, key, iconType } = option;
            const isSelected = key === selectedValue;
            const isDisabled = !possibleOptionsCleared.some((item) => item.key === key) ||
                possibleOptionsCleared.some((item) => item.key === key && Boolean(item.isDisabled));
            const keyItem = buildKey('ButtonRectangleRadioGroup', `${keyOfColorGroup}_${index}`);
            const isCasePositive = Boolean(value !== NA_VALUE && value.trim() !== '' && value !== UNIQUE_SIZE);
            return isCasePositive ? (React.createElement(ButtonRectangleRadio, { isWidthFlexible: (allOptionsCleared.length === 1 && (isTabletView || isLargeDesktopView)) ||
                    isWidthFlexible, key: keyItem, index: index, allowClickOnDisabled: allowClickOnDisabled, isSelected: allowClickOnDisabled ? isSelected : !isDisabled && isSelected, isDisabled: isDisabled, value: value, isRadioVisible: isRadioVisible, setIsActive: (isDisabled && !allowClickOnDisabled) || isSelected ? noop : setIsActiveHandler(key), tagContent: contentTag, dataTestId: dataTestId, iconType: iconType })) : null;
        })));
    }
    return null;
}
ButtonRectangleRadioGroup.displayName = 'ButtonRectangleRadioGroup_Atom';
